import { render } from "./configure.vue?vue&type=template&id=d458182e&scoped=true"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"

import "./configure.vue?vue&type=style&index=0&id=d458182e&scoped=true&lang=less"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d458182e"]])

export default __exports__